<template>
  <!-- 专题活动 -->
  <div id="Notice">
    <Header></Header>
    <Navigate></Navigate>
    <div class="content">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{name:'home'}">首页</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span><a>通知公告</a></span>
      </div>
      <div class="content_body">
        <div class="content_body_left">
          <BannerLeft></BannerLeft>
        </div>
        <div class="content_body_right">
          <router-view></router-view>
        </div>
      </div>
      <div style="clear:both"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@/components/public/heade/index'
import Navigate from '@/components/public/navigation/index'
import Foot from '@/components/public/foot/index'
import BannerLeft from '@/components/public/bannerLeft/index'

export default {
  name:'Notice',
  data(){
    return{
      DataDownloadList:[
        {
          name:'NonMember',
          title:'非会员'
        }
      ]
    }
  },
  components:{
    Header,
    Navigate,
    Foot,
    BannerLeft
  }
}
</script>

<style lang="less" scoped>
  #Notice{
    .content{
      width:1200px;
      height:100%;
      margin:0 auto;
      .crumbs{
        width:1200px;
        height:20px;
        position:relative;
        text-align:left;
        margin-top:24px;
        margin-left: 2%;
        line-height:20px;
        span:nth-child(2) a{
          color:#000000;
          font-size:16px;
          font-weight:bold;
          cursor:pointer;
        }
        i{
          color:#767C82;
          font-size:18px;
          margin-left:10px;
          font-weight:bold;
        }
        i:nth-child(1){
          color:#000;
          margin-right:5px;
        }
        span:nth-child(4) a{
          color:#C01B22;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
      }
      .content_body{
        width: 1130px;
    height: 100%;
    margin-left: 3%;
    margin-top: 20px;
    // border: 1px solid #bbbbbb;
        .content_body_left{
          width:280px;
          height:100%;
          float:left;
        }
        .content_body_right{
          width: 1130px;
          //  width: 960px;
        height: auto;
        // margin-left: 3%;
          height:100%;
          // float:right;
          // margin-left:15px;
        }
      }
    }
  }
  /deep/.content_body_left_divC{
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notice/index.vue